var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "design-layout-preview",
    attrs: {
      id: "design-middle-layout"
    },
    on: {
      click: function click($event) {
        if ($event.target !== $event.currentTarget) return null;
        return _vm.$store.dispatch("design/form_close");
      }
    }
  }, [_c("div", {
    staticClass: "layout-wrapper"
  }, [_c("div", {
    staticClass: "main-layout",
    class: _vm.platform == "m" ? "is-app" : "",
    style: {
      transform: "scale(" + _vm.scale + ")"
    }
  }, [_c("nexted"), _vm.components.length <= 0 ? _c("div", {
    staticClass: "is-empty"
  }, [_c("img", {
    attrs: {
      src: _vm.images.emptyImage
    }
  }), _vm._v(" " + _vm._s(_vm.$t("com.emptyCom")) + " ")]) : _vm._e()], 1)])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };